import React from "react";
import FloorFilterDropdown from "@/components/util/FloorFilterDropdown";
import { useReserveForm } from "@/components/reserve/Reserve/ReserveFormProvider";
import { FloorIcon } from "@v2/icons";

export const ReserveFormFloorSelector: React.FC = () => {
  const { resource, floors, filterFloor, setFilterFloor } = useReserveForm();
  return (
    <FloorFilterDropdown
      readonly={!!resource}
      floors={floors ?? []}
      floor={filterFloor}
      setFloor={setFilterFloor}
      customIcon={<FloorIcon className="h-4 w-4 opacity-50" />}
    />
  );
};
